module.exports = __webpack_public_path__ + "static/media/rule3.3fae5e9f.png";